var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeSideBar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 42,
    viewBox: "0 0 34 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9999 0.776855L0.333252 17.4435V41.8333H10.7499H23.2499H33.6666V17.4435L16.9999 0.776855ZM12.8333 39.75V27.25H21.1666V39.75H12.8333ZM31.5833 39.75H23.2499V25.1666H10.7499V39.75H2.41659V18.3064L16.9999 3.72307L31.5833 18.3064V39.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeSideBar);
export default __webpack_public_path__ + "static/media/homeSideBar.8191bd8fbcc0d355dc7858c8d4c3aa0b.svg";
export { ForwardRef as ReactComponent };